export default str => {
  return str[0].toUpperCase() + str.slice(1)
}
